import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const rollingBottleBlock = document.querySelectorAll(".rolling-bottle");

  rollingBottleBlock.forEach((block) => {
    const blockWrapper = block.querySelector(".blocks-wrapper");
    const imgWrapper = blockWrapper.querySelector(".wp-block-image");
    const img = imgWrapper.querySelector("img");
    const textBlock = blockWrapper.querySelector(".wp-block-group");

    // add timeline
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: "top bottom",
        end: "bottom top",
        scrub: 1,
        // pin: true,
        // pinSpacing: false,
      },
    });
    tl.fromTo(
      img,
      {
        transformOrigin: "top center",
        // scale: 0.4,
        height: "50dvh",
        yPercent: 20,
        top: "5vh",
        opacity: 0.5,
      },
      {
        // scale: 1,
        height: "calc(100% - 15dvh)",
        yPercent: 30,
        opacity: 1,
        top: 0,
        ease: "expo.inOut",
      }
    );
  });
});
